export default {
    list: (state) => {
        return state.list
    },
    current_contact: (state) => {
        return state.current_contact
    }
}